import React from "react";
import { CircularProgress, Box } from "@mui/material";

const GlobalLoader = () => {
  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "transparent",
        backdropFilter: "blur(4px)",
        zIndex: 99999,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <CircularProgress
        size={60}
        thickness={4}
        sx={{ color: "var(--color-primary)" }}
      />
    </Box>
  );
};

export default GlobalLoader;
